import { render, staticRenderFns } from "./TileTravelCollectItemAssets.vue?vue&type=template&id=8da84a4e"
import script from "./TileTravelCollectItemAssets.vue?vue&type=script&lang=js"
export * from "./TileTravelCollectItemAssets.vue?vue&type=script&lang=js"
import style0 from "./TileTravelCollectItemAssets.vue?vue&type=style&index=0&id=8da84a4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports